import { nanoid } from '@reduxjs/toolkit';

const id = nanoid();

export default function FileMinus({ color = '#000000', ...props }: Record<string, unknown> & { color?: string }) {
  return (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <title>file-minus</title>
      <defs>
        <path
          d="M11,0 C11.0425909,0 11.0845598,0.00266261633 11.1257495,0.00783047292 L11,0 C11.0528361,0 11.1052411,0.00418141391 11.1567725,0.0123609877 C11.1883933,0.0172035954 11.2193064,0.0236158178 11.249662,0.0314174347 C11.2598053,0.0342797004 11.2698902,0.0370498784 11.2799252,0.0399762024 C11.3109399,0.0487322365 11.3413507,0.059226165 11.3710585,0.0711039637 C11.3800191,0.0749695695 11.3890567,0.0787341995 11.3980377,0.0826308894 C11.4262995,0.0946381533 11.4536613,0.108067907 11.4802859,0.122674361 C11.4906553,0.128558233 11.5012587,0.134613306 11.5117542,0.140864684 C11.5399066,0.15749759 11.5670269,0.175549461 11.5931738,0.194844517 C11.5995817,0.199634907 11.6064603,0.204834375 11.6132762,0.210126665 C11.6177282,0.213538884 11.6216003,0.216599882 11.625449,0.219688767 L11.7071068,0.292893219 L17.7071068,6.29289322 C17.7364445,6.32223095 17.7639678,6.3533831 17.7894939,6.38616693 L17.7071068,6.29289322 C17.7429509,6.32873733 17.7757929,6.36702236 17.8054709,6.40735764 C17.8244505,6.43297305 17.8425024,6.46009338 17.8592238,6.48809993 C17.8653867,6.49874131 17.8714418,6.50934473 17.8772982,6.52005033 C17.8919321,6.54633874 17.9053618,6.57370048 17.9175449,6.60172936 C17.9212658,6.61094326 17.9250304,6.61998091 17.9286618,6.62907226 C17.9407738,6.65864932 17.9512678,6.68906007 17.9602981,6.72009403 C17.9629501,6.73010978 17.9657203,6.7401947 17.9683328,6.75032594 C17.9763842,6.78069364 17.9827964,6.81160666 17.9877474,6.84300527 C17.9892866,6.85360724 17.990772,6.86402246 17.9920936,6.8744695 C17.9973374,6.91544017 18,6.95740914 18,7 L18,19 C18,20.6568542 16.6568542,22 15,22 L3,22 C1.34314575,22 0,20.6568542 0,19 L0,3 C0,1.34314575 1.34314575,0 3,0 Z M10,2 L3,2 C2.44771525,2 2,2.44771525 2,3 L2,19 C2,19.5522847 2.44771525,20 3,20 L15,20 C15.5522847,20 16,19.5522847 16,19 L16,8 L11,8 C10.4871642,8 10.0644928,7.61395981 10.0067277,7.11662113 L10,7 L10,2 Z M12,13 C12.5522847,13 13,13.4477153 13,14 C13,14.5522847 12.5522847,15 12,15 L6,15 C5.44771525,15 5,14.5522847 5,14 C5,13.4477153 5.44771525,13 6,13 Z M12,3.415 L12,6 L14.586,6 L12,3.415 Z"
          id={id}
        />
      </defs>
      <g id="🕹-Icons" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
        <g id="Feather" transform="translate(-467, -526)">
          <g id="file-minus" transform="translate(470, 527)">
            <mask id={`mask-${id}`} fill="white">
              <use xlinkHref={`#${id}`} />
            </mask>
            <use id="Combined-Shape" fill={color} fillRule="nonzero" xlinkHref={`#${id}`} />
            <g id="COLOR/-black" mask={`url(#mask-${id})`} fill={color}>
              <g transform="translate(-3, -1)" id="Rectangle">
                <rect x={0} y={0} width={24} height={24} />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
